/**
 * @file: RefreshHeaderButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A nav-header reload affordance for list screens, sized to sit alongside the
 * other round header buttons. WEB ONLY by design: native reloads by pulling the
 * list, which react-native-web cannot offer — leaving the browser with no way to
 * refresh at all. Dimmed and inert while a reload is in flight, since on web
 * there is no RefreshControl spinner to signal it.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { RotateCw } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';

export const RefreshHeaderButton = memo(
  ({ onPress, refreshing }: { onPress: () => void; refreshing: boolean }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={onPress}
        disabled={refreshing}
        style={{
          width: rpx(36),
          height: rpx(36),
          borderRadius: rpx(18),
          marginRight: rpx(8),
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: LD.surface,
          opacity: refreshing ? 0.45 : 1,
          shadowColor: '#1B2A44',
          shadowOpacity: 0.08,
          shadowRadius: rpx(6),
          shadowOffset: { width: 0, height: rpx(2) },
          elevation: 2,
        }}
      >
        <RotateCw size={rpx(19)} color={LD.brand} />
      </TouchableOpacity>
    );
  },
);
